import { toValue, type MaybeRefOrGetter } from 'vue'

export interface ExperienceQueryPartitionInput {
  readonly locationId: string
  readonly viewerId: string
  readonly locale: string
  readonly authorizationScope: string
}

const requiredPartitionFields = ['locationId', 'viewerId', 'locale', 'authorizationScope'] as const

export const createExperienceQueryPartition = (
  input: ExperienceQueryPartitionInput
): readonly ['experience-partition-v1', string, string, string, string] => {
  for (const field of requiredPartitionFields) {
    if (!input[field].trim()) throw new Error(`Experience query partition requires ${field}`)
  }

  return ['experience-partition-v1', input.locationId, input.viewerId, input.locale, input.authorizationScope]
}

export type ExperienceQueryPartition = ReturnType<typeof createExperienceQueryPartition>

export const prefixExperienceQueryKey = <TQueryKey extends readonly unknown[]>(
  queryKey: TQueryKey,
  partition?: MaybeRefOrGetter<ExperienceQueryPartition | undefined>
): readonly unknown[] => {
  const resolvedPartition = partition ? toValue(partition) : undefined

  return resolvedPartition ? [...resolvedPartition, ...queryKey] : queryKey
}

/**
 * An omitted partition keeps legacy query behavior. A provided reactive
 * partition is fail-closed until its trusted identity has resolved.
 */
export const isExperienceQueryPartitionReady = (partition?: MaybeRefOrGetter<ExperienceQueryPartition | undefined>): boolean =>
  partition === undefined || toValue(partition) !== undefined
